import { Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// Instead of doing the same sort of merge([child events]) logic
// through RXJS, we can provide this class at the component level
// and a parent component can have it's children subscribe to an instance
// of this to listen to any child events
@Injectable()
export class ChildEventChannel {
  private _subject = new Subject();
  emit(data: any) {
    this._subject.next(data);
  }

  get events(): Observable<any> {
    return this._subject.asObservable();
  }
}
